// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { DefaultPage } from '../Pasajebus/PasajebusServiceList';

export default {
  path: 'en',
  name: 'En routes',
  childRoutes: [
    {
      path: 'bus/:originOnward/:destOnward/:journeyDateOnward',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/features/en-routes/route.js